import { decorate } from '../definition/decorator';
import { registryDevtools } from './registryDevtools';
import { getDefaultHttpClient } from '../../client/defaultHttpClient';
import { createPersistenceDecorator } from '../../persistence/decorator';
import { lifecycleRules } from '../decorators/lifecycleRules';
import { changeHandling } from '../decorators/changeHandling';
export const createResolverRegistry = ({
  logger,
  persistenceManager
}) => {
  const registeredResolvers = new Map();
  const attachments = new Map();
  logger === null || logger === void 0 || logger.debug('startup');
  return {
    isAttached: instanceKey => attachments.has(instanceKey),
    attach: ({
      resource,
      instanceKey,
      params,
      resolver: resolverArg,
      getState,
      onResolverUpdate,
      httpClient
    }) => {
      const attachLogger = logger === null || logger === void 0 ? void 0 : logger.withTags({
        instanceKey
      });
      if (attachments.has(instanceKey)) {
        attachLogger === null || attachLogger === void 0 || attachLogger.error('duplicate attachment');
        throw Error(`Duplicate attachment for ${instanceKey}`);
      }
      const {
        typeName,
        persist
      } = resource;
      if (!registeredResolvers.has(typeName)) {
        attachLogger === null || attachLogger === void 0 || attachLogger.info('registering resolver');
        registeredResolvers.set(typeName, [lifecycleRules, changeHandling, ...(persistenceManager && persist ? [createPersistenceDecorator(persistenceManager, persist)] : [])].reduce((decorated, decorator) => decorated.with(decorator), decorate(resolverArg)));
      }
      const resolver = registeredResolvers.get(typeName);
      attachLogger === null || attachLogger === void 0 || attachLogger.debug('attaching resolver');
      attachments.set(instanceKey, resolver.attach(params, {
        next: onResolverUpdate,
        getState,
        env: {
          httpClient: httpClient !== null && httpClient !== void 0 ? httpClient : getDefaultHttpClient(),
          instanceKey,
          resource,
          logger: attachLogger === null || attachLogger === void 0 ? void 0 : attachLogger.withTags({
            component: 'resolver'
          })
        }
      }));
    },
    detach: instanceKey => {
      const detachLogger = logger === null || logger === void 0 ? void 0 : logger.withTags({
        instanceKey
      });
      const attachment = attachments.get(instanceKey);
      if (!attachment) {
        detachLogger === null || detachLogger === void 0 || detachLogger.error('no attachment found');
        throw Error(`Attempting to detach ${instanceKey} but no attachment found`);
      }
      detachLogger === null || detachLogger === void 0 || detachLogger.info('detaching resolver');
      attachment.detach();
      attachments.delete(instanceKey);
    },
    refresh: (instanceKey, changeContext) => {
      const refreshLogger = logger === null || logger === void 0 ? void 0 : logger.withTags({
        instanceKey,
        changeId: changeContext === null || changeContext === void 0 ? void 0 : changeContext.changeId,
        originId: changeContext === null || changeContext === void 0 ? void 0 : changeContext.originId
      });
      const attachment = attachments.get(instanceKey);
      if (!attachment) {
        refreshLogger === null || refreshLogger === void 0 || refreshLogger.error('no attachment found');
        throw Error(`Attempting to refresh ${instanceKey} but no attachment found`);
      }
      refreshLogger === null || refreshLogger === void 0 || refreshLogger.info('refreshing resolver');
      attachment.refresh(changeContext);
    },
    __devtools: registryDevtools(registeredResolvers)
  };
};